import { isFirestoreWriteConflict } from './firestore';

export type SaveStatus = 'none' | 'saving' | 'done' | 'offline' | 'error';

export type SaveFailure = 'conflict' | 'network' | 'other';

const NETWORK_ERROR_CODES = new Set(['unavailable', 'deadline-exceeded']);
const MAX_RETRY_DELAY_MS = 30_000;

export const classifySaveFailure = (error: unknown): SaveFailure => {
  if (isFirestoreWriteConflict(error)) return 'conflict';
  const code = (error as { code?: string } | null)?.code ?? '';
  if (NETWORK_ERROR_CODES.has(code) || !navigator.onLine) return 'network';
  return 'other';
};

/** Backoff before the next attempt after `attempt` consecutive failures. */
export const getRetryDelay = (attempt: number) =>
  Math.min(MAX_RETRY_DELAY_MS, 1000 * 2 ** Math.max(0, attempt - 1));

/** A new edit shows "Saving…", unless offline or saves are already failing. */
export const markSaving = (status: SaveStatus): SaveStatus => {
  if (!navigator.onLine) return 'offline';
  return status === 'offline' || status === 'error' ? status : 'saving';
};

/** Waits `ms`, or less if the browser comes back online first. */
export const waitForRetry = (ms: number) =>
  new Promise<void>((resolve) => {
    const done = () => {
      clearTimeout(timer);
      window.removeEventListener('online', done);
      resolve();
    };
    const timer = setTimeout(done, ms);
    window.addEventListener('online', done);
  });
